import { all } from "redux-saga/effects"
import read from "./read"
import update from "./update"
import remove from "./remove"

export default function*() {
  while (true) {
    yield all({
      read: read(),
      update: update(),
      remove: remove(),
    })
  }
}
